"use client"

import styled from "@emotion/styled"
import { useInView } from "react-intersection-observer"
import colors from "theme/colors"
import ReadMoreIcon from "tierraComponents/Newsroom/ReadMoreIcon"
import { Container, NewText, transitionDelayTime, TransitionUp, useInViewConfig } from "ui"
import ImageWithAlt from "ui/ImageWithAlt"
import { extractImage, extractProperty, getLinkHrefFromMultiUrlPickerItem } from "utils"
const StyledPartners = styled.div`
  display: grid;
  grid-template-columns: 1fr;

  grid-row-gap: 36px;
  padding: 56px 0;
  img {
    width: auto !important;
  }
  ${(props) => props.theme.breakpoints.up("md")} {
    grid-template-columns: repeat(3, 1fr);
    grid-row-gap: 28px;
    grid-column-gap: 15.5px;

    padding: 112px 0;
  }
`
const StyledPartner = styled.div`
  padding: 24px 16px;
  border: 2px solid var(--DarkGreen, #5b7553);
  border-radius: 12px;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: 32px;
  }
`

const StyledLogo = styled.div`
  position: relative;
  height: 80px;
  width: 100%;
`

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  background: transparent;
  border: none;
  margin: 0px;
  padding: 0px;
  display: flex;
  gap: 8px;
  margin: 0px;
  padding: 0px;
  height: 20px;
  margin-top: 24px;
  cursor: pointer;
`
const StyledTextContainer = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 70px;
  margin-top: 16px;
  ${(props) => props.theme.breakpoints.up("md")} {
    height: 72px;
  }
`

type Props = { data: any }

function BonitaPartners({ data }: Props) {
  const arrayToMap = extractProperty(data, "partnersItems")
  const { ref: mobileRef, inView: mobileInView } = useInView(useInViewConfig)

  return (
    <Container>
      <StyledPartners ref={mobileRef}>
        {arrayToMap?.map((partner: any, index: number) => {
          const image = extractImage(partner, "logo")
          const PartnersName = extractProperty(partner, "PartnersName")
          const link = extractProperty(partner, "link")

          return (
            <TransitionUp
              key={index.toString()}
              $inView={mobileInView}
              $delay={transitionDelayTime * 0.5 * index}
            >
              <StyledPartner key={index.toString()}>
                <StyledLogo>
                  <ImageWithAlt image={image} fill style={{ objectFit: "contain" }} />
                </StyledLogo>
                <StyledTextContainer>
                  <NewText
                    component={"h2"}
                    desktopFontSize={32}
                    desktopLineHeight={"36px"}
                    desktopFontWeight={400}
                    mobileFontSize={24}
                    mobileLineHeight={"35px"}
                    color={colors.boniteDarkBlue}
                  >
                    {PartnersName}
                  </NewText>
                </StyledTextContainer>
                <a
                  style={{
                    textDecorationColor: colors.darkGreen,
                    textTransform: "none",
                  }}
                  target="_blank"
                  href={getLinkHrefFromMultiUrlPickerItem(link?.[0])}
                >
                  <StyledButton>
                    <NewText
                      component={"p"}
                      desktopFontSize={18}
                      desktopLineHeight={"26px"}
                      desktopFontWeight={700}
                      mobileFontSize={14}
                      mobileLineHeight={"20px"}
                      color={colors.darkGreen}
                    >
                      {link?.[0]?.name}
                    </NewText>{" "}
                    <ReadMoreIcon />
                  </StyledButton>
                </a>
              </StyledPartner>
            </TransitionUp>
          )
        })}
      </StyledPartners>
    </Container>
  )
}

export default BonitaPartners
